<ng-container *ngIf="page && brConfig?.fundId; else previewBlock">
  <div class="top-part">
    <!-- if its Segregated fund-->
    <div class="d-flex fund-head mt-2" *ngIf="isSegregated">
      <div class="segregated">
        <h1 class="mb-0" style="font-size: 1.5rem">
          <a>
            <span [innerHTML]="fundTitle"> </span>
          </a>
        </h1>
      </div>
    </div>
    <!-- Non Segregated funds goes below-->
    <div class="container" *ngIf="!isSegregated ">
      <div class="FT-fund-statistics">
        <div id="fund-block-wraper"
             class="fund-block row mb-4 justify-content-between align-items-center relative-block new-block flex-nowrap"
             [ngClass]="showCalcBox ? 'hidden-calc-box' : 'show-calc-box'" style="height:auto;" *ngIf="isLoaded">
          <div class="col-lg col-xl-auto">
            <div class="position-relative">
              <div class="d-flex align-items-center"
                   [ngClass]="isFocusFund ? 'justify-content-between' : 'justify-content-end'">
                <span *ngIf="isFocusFund" class="recommend-tag">{{ badgeValue }}</span>
                <div class="icons">
                  <!--mobile view for icons start -->
                  <div class="dropdown d-inline-block d-lg-none">
                    <button class=" dropdown-toggle me-0" type="button" data-bs-toggle="dropdown"
                            aria-expanded="false">
                      <img alt='image' src="assets/images/general/dots.webp">
                    </button>
                    <ul class="dropdown-menu">
                      <li>
                        <a class="dropdown-item" *ngIf="!isFundInComparelist"
                           (click)="toggleShowComparedDialoge('add', fund)">
                          <img alt="compare"
                               src="assets/images/general/compare-icon.webp">{{ "products.home-fund-card-compare-btn" | translate }}
                        </a>
                        <a class="dropdown-item remove-from-watchlist" *ngIf="isFundInComparelist"
                           (click)="toggleShowComparedDialoge('remove', fund)">
                          <img alt="compare"
                               src="assets/images/general/_Checkboxbase.svg">{{ "products.home-fund-card-added-compare-btn" | translate }}
                        </a>
                      </li>
                      <li>
                        <span class="dropdown-item d-block" (click)="toggleWatchListDialoge('add', fund)"
                              *ngIf="!isFundInWatchlist">
                          <img alt="watchlist"
                               src="assets/images/general/watchlist-icon.webp">{{ "products.home-fund-card-add-to-wlist-btn" | translate }}
                        </span>

                        <span class="dropdown-item d-block" (click)="toggleWatchListDialoge('remove',fund)"
                              *ngIf="isFundInWatchlist">
                          <img alt="Watchlist"
                               src="assets/images/general/Frame1000006555.svg">{{ "products.home-fund-card-added-to-wlist-btn" | translate }}
                        </span>
                      </li>
                      <li>
                        <a class="dropdown-item" data-bs-toggle="modal" data-bs-target="#callBack1"
                           (click)="shareFund()">
                          <img alt='image' src="assets/images/general/share-icon-sm.webp">
                          {{ "products.fund-header-share" | translate }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div><!--mobile view for icons end -->
              </div>
              <div class="d-flex fund-head mt-2 mb-2">
                <div class="d-none d-md-flex" style="min-width: 500px;max-width: 505px;">
                  <h1 class="mb-0">
                    <a>
                      <span [innerHTML]="fundTitle"> </span>
                    </a>
                  </h1>
                </div>
                <div class="d-md-none">
                  <h1 class="mb-15">
                    <a>
                      <span [innerHTML]="fundTitle"> </span>
                      <span style="float: right;" *ngIf="fundRiskName" class="img-with-tooltip"
                            (click)="scrollToRiskometer()">
                        <img alt='image' src="assets/images/general/very-high.webp">
                        <span class="tooltip-block" style="min-width: 127px;left: -148px;">
                          <img alt='image' src="assets/images/general/very-high.webp">
                          {{ fundRiskName }}
                        </span>
                      </span>
                    </a>
                  </h1>
                </div>

                <div class="d-none d-md-block" *ngIf="fundRiskName">
                  <span class="img-with-tooltip" (click)="scrollToRiskometer()">
                    <img alt='image' src="assets/images/general/very-high.webp">
                    <span class="tooltip-block">
                      <img alt='image' src="assets/images/general/very-high.webp">
                      {{ fundRiskName }}
                    </span>
                  </span>
                </div>
                <div class="icons">
                  <!--desktop icon view starts -->
                  <div class="d-none d-lg-inline-block">
                    <button (click)="toggleWatchListDialoge('add', fund)" *ngIf="!isFundInWatchlist">
                      <img alt='image' src="assets/images/general/mark-icon.webp">
                      <span class="tooltip-box">{{ "products.fund-header-watchlist" | translate }}</span>
                    </button>
                    <button (click)="toggleWatchListDialoge('remove',fund)" *ngIf="isFundInWatchlist">
                      <img alt='image' src="assets/images/general/Frame1000006555.svg">
                      <span class="tooltip-box">{{ "products.home-fund-card-added-to-wlist-btn" | translate }}</span>
                    </button>
                    <button *ngIf="!isFundInComparelist" (click)="toggleShowComparedDialoge('add', fund)">
                      <img alt='image' src="assets/images/general/change-icon.svg">
                      <span class="tooltip-box">{{ "products.home-fund-card-compare-btn" | translate }}</span>
                    </button>

                    <button *ngIf="isFundInComparelist" (click)="toggleShowComparedDialoge('remove', fund)">
                      <img alt='image' src="assets/images/general/_Checkboxbase.svg">
                      <span class="tooltip-box">{{ "products.home-fund-card-added-compare-btn" | translate }}</span>
                    </button>
                    <!--<button>
                      <a href="/funds-and-solutions/tools/cart">
                        <img alt='image' src="assets/images/general/cart-icon.svg"><span class="new-badge">New</span>
                        <span class="tooltip-box">{{ "products.fund-header-add-to-cart" | translate }}</span>
                      </a>
                    </button>-->
                    <button aria-label="Share button">
                      <div class="dropdown share-menu">
                        <button aria-label="Share button" class="btn btn-secondary dropdown-toggle" type="button"
                                data-bs-toggle="dropdown" aria-expanded="false" (click)="shareFund()">
                          <img alt="Share icon" src="assets/images/general/share-icon.webp"
                               class="d-inline-block mobile-icons light-mode-icon" style="width: 22px;">
                          <img alt="Share icon" src="assets/images/dark/dark-share-icon.png" class="mobile-icons dark-mode-icon"
                               style="position: relative; bottom: 2px;">
                          <span class="tooltip-box">{{ "products.fund-header-share" | translate }}</span>
                        </button>
                        <ul class="dropdown-menu">
                          <li><span class="dropdown-item" (click)="toggleShowCopyDialoge(true)">
                            <img alt="Copy" class="share-icon"
                                 src="assets/images/general/Link.webp">{{ "products.home-fund-card-share-copy-btn" | translate }}</span>
                          </li>
                          <li>
                            <a class="dropdown-item" (click)="shareOnApp('TWITTER')">
                              <img alt='TWITTER' src="assets/images/general/twitter-new.webp"
                                   class="share-icon light-mode-icon"
                                   style="width: 22px;">
                              <img alt='TWITTER'
                                   src="https://franklintempletonprod.widen.net/content/r4meov4ast/original/brandico_twitter-bird.png"
                                   class="share-icon dark-mode-icon"
                                   style="width: 22px; float: left">
                              Share on Twitter</a>
                          </li>
                          <li><a class="dropdown-item" (click)="shareOnApp('FACEBOOK')">
                            <img alt="FB"
                                 class="share-icon"
                                 src="assets/images/general/FacebookLogo.webp">Share
                            on Facebook</a></li>
                          <li><a class="dropdown-item" (click)="shareOnApp('LINKEDIN')">
                            <img alt="Linkdin"
                                 class="share-icon"
                                 src="assets/images/general/LinkedinLogo.webp">Share
                            on LinkedIn</a></li>
                          <li><a class="dropdown-item" (click)="shareOnApp('WHATAPP')">
                            <img alt="Whatsapp"
                                 class="share-icon"
                                 src="assets/images/general/whatsapps.webp">Share
                            on WhatsApp</a></li>
                        </ul>
                      </div>
                    </button>
                  </div>
                </div><!--desktop icon view ends -->
              </div>
              <div class="d-md-flex align-items-center mb-3">
                <div class="tags">
                  <ul class="list-inline m-0 p-0">
                    <li class="list-inline-item">{{ removeFundString(assetclass) }}</li>
                    <li class="list-inline-item">{{ removeFundString(invfocus) }}</li>
                    <li class="list-inline-item">{{ fundAge | yearsOld }}</li>
                  </ul>
                </div>
                <div [ngClass]="showCalcBox ? 'd-none' : ''">
                  <span class="note mt-2 d-none d-md-block"
                        *ngFor="let benchmark of additionalInfo?.benchmarks">
                    {{ "products.overview-benchmarks" | translate }} : {{ benchmark }}
                  </span>
                  <span class="d-md-none mt-2 text-small"
                        *ngFor="let benchmark of additionalInfo?.benchmarks">
                    {{ "products.overview-benchmarks" | translate }} : {{ benchmark }}
                  </span>
                </div>
              </div>
              <div class="fund-num ml-2 d-none d-md-flex">
                <div class="text-big d-none d-md-block"
                     *ngIf="additionalInfo?.fundSize !== '' && additionalInfo?.fundSize">
                  <img alt='image' src="assets/images/fund/money-sign.svg">
                  {{ Number(parseFloat(additionalInfo?.fundSize).toFixed(2)) | INRCurrencyNumber }}&nbsp;{{ "products.cr" | translate }}
                  <span class="text-gray"> {{ "products.aum" | translate }}
                    <span class="img-with-tooltip">
                      <img alt='image' src="assets/images/home/info-icon2.svg" class="light-mode-icon">
                      <img alt='image' src="assets/images/fund/dark-information-icon.png" class="dark-mode-icon"
                           style="display:inherit!important;">
                      <span class="tooltip-block text-center">
                        {{ "products.as-of-capitalize" | translate }}&nbsp;{{ additionalInfo?.fundInfoDate }}
                      </span>
                    </span>
                  </span>
                </div>
                <div class="text-big d-none d-md-block"
                     *ngIf="fundDocument?.funduniqueinvestors !== '' && fundDocument?.funduniqueinvestors ">
                  <img alt='image' src="assets/images/fund/investor-icon.svg">
                  {{ (Number((fundDocument?.funduniqueinvestors).replace(',', '')) | INRCurrencyNumberInt) }}
                  <span class="text-gray">&nbsp;{{ "products.existing-investors" | translate }}
                    <span class="img-with-tooltip">
                      <img alt='image' src="assets/images/home/info-icon2.svg" class="light-mode-icon">
                      <img alt='image' src="assets/images/fund/dark-information-icon.png" class="dark-mode-icon"
                           style="display:inherit!important;">
                      <span class="tooltip-block text-center">
                        {{ "products.as-of-capitalize" | translate }}&nbsp;{{ lastQuarterEndDate }}
                      </span>
                    </span>
                  </span>
                </div>
              </div>
              <div class="fund-num d-md-none justify-content-between" style="max-width: 300px;">
                <div class="text-small d-md-none"
                     *ngIf="fundDocument?.funduniqueinvestors !== '' && fundDocument?.funduniqueinvestors">
                  <span class="text-gray">{{ "products.existing-investors" | translate }}
                    <span class="img-with-tooltip" style="margin-left: 3px;">
                      <img alt='image' src="assets/images/home/info-icon2.svg" class="light-mode-icon">
                      <span class="tooltip-block text-center">
                        {{ "products.as-of-capitalize" | translate }}{{ lastQuarterEndDate }}
                      </span>
                    </span>
                    <br>
                    <span class="img-with-tooltip">
                      <img alt='image' src="assets/images/fund/investor-icon.svg">
                      {{ (Number((fundDocument?.funduniqueinvestors).replace(',', '')) | INRCurrencyNumberInt) }}
                      <img alt='image' src="assets/images/fund/dark-information-icon.png" class="dark-mode-icon"
                           style="display:inherit!important">
                      <span class="tooltip-block text-center" style="margin-left: 185px;">
                        {{ "products.as-of-capitalize" | translate }}{{ lastQuarterEndDate }}
                      </span>
                    </span>
                  </span>
                </div>
                <div class="text-small d-md-none">
                  <span class="text-gray" *ngIf="additionalInfo?.fundSize !== '' && additionalInfo?.fundSize"> Fund Size
                    <span class="img-with-tooltip" style="margin-left: 3px;">
                      <img alt='image' src="assets/images/home/info-icon2.svg" class="light-mode-icon">
                      <span
                          class="tooltip-block text-center">{{ "products.as-of-capitalize" | translate }} {{ additionalInfo?.fundInfoDate }}</span>
                    </span>
                    <br>
                    <span class="img-with-tooltip">
                      <img alt='image' src="assets/images/fund/money-sign.svg">
                      {{ Number(parseFloat(additionalInfo?.fundSize).toFixed(2)) | INRCurrencyNumber }} {{ "products.cr" | translate }}
                      <img alt='image' src="assets/images/fund/dark-information-icon.png" class="dark-mode-icon"
                           style="display:inherit!important">
                      <span class="tooltip-block text-center" style="margin-left: 125px;">
                        {{ "products.as-of-capitalize" | translate }} {{ additionalInfo?.fundInfoDate }}
                      </span>
                    </span>
                  </span>
                </div>
              </div>
              <div class="info block-footer">
                <ul class="d-flex align-items-center">
                  <!-- <li>
                    <div class="mb-2" style="cursor: pointer;">
                      <span [innerHTML]="'products.returns-since-inception' | translate"
                            (click)="moveToPerformance()"></span>
                      <span class="img-with-tooltip" *ngIf="sinceInceptionReturn">
                        <img alt='image' src="assets/images/home/info-icon2.svg" class="light-mode-icon">
                        <img alt='image' src="assets/images/fund/dark-information-icon.png" class="dark-mode-icon"
                             style="display:none">
                        <span class="tooltip-block text-center" style="min-width: 175px;">
                          {{ "products.as-of-capitalize" | translate }}&nbsp;{{ lastQuarterEndDate }}
                        </span>
                      </span>
                    </div>
                    <div class="text-big">{{ sinceInceptionReturn ? sinceInceptionReturn : 'NA' }}</div>
                  </li> -->
                  <li *ngIf="navDroopdownName" class="drop-down-menuList">
                    <div class="dropdown small-dropdown">
                      <button class="btn btn-white dropdown-toggle" type="button" id="dropdownMenuButton1"
                              data-bs-toggle="dropdown" aria-expanded="false">
                        {{ navDroopdownName }}
                      </button>
                      <ul class="dropdown-menu dropdownAlingment" aria-labelledby="dropdownMenuButton1">
                        <li *ngFor="let menu of fundInformationNav?.shareClasses"
                            [ngClass]="menu.name === 'Growth'? 'text-center' : ''"
                            class="menuDropdown-li"
                            (click)="onfundPlansChange(menu)"><a
                            class="dropdown-item funDropDown text-center mx-2">{{ menu.name }}</a>
                        </li>
                      </ul>
                    </div>
                  </li>

                  <li [ngClass]="showCalcBox ? 'd-none' : ''">
                    <div class="mb-2">
                      <span [innerHTML]="'products.overview-expense-ratio' | translate"></span>
                      <span class="img-with-tooltip"
                            *ngIf="planBasedExpenseRatio && additionalInfo?.fundInfoDate && planBasedExpenseRatio !== '—'">
                        <img alt='image' src="assets/images/home/info-icon2.svg" class="light-mode-icon">
                        <img alt='image' src="assets/images/fund/dark-information-icon.png" class="dark-mode-icon"
                             style="display:none">
                        <span class="tooltip-block text-center" style="min-width: 144px; left: -110px;">
                          {{ "products.as-of-capitalize" | translate }}&nbsp; {{ additionalInfo?.fundInfoDate }}
                        </span>
                      </span>
                    </div>
                    <div class="text-big">
                      {{ planBasedExpenseRatio ? planBasedExpenseRatio : 'NA' }}
                    </div>
                  </li>
                  <li [ngClass]="showCalcBox ? 'd-none' : ''">
                    <div class="mb-2"> {{ "products.nav" | translate }}
                      <span class="img-with-tooltip" *ngIf="navDroopdownValue">
                        <img alt='image' src="assets/images/home/info-icon2.svg" class="light-mode-icon">
                        <img alt='image' src="assets/images/fund/dark-information-icon.png" class="dark-mode-icon"
                             style="display:none">
                        <span class="tooltip-block text-center addTooltiModeBlock">
                          {{ "products.as-of-capitalize" | translate }}&nbsp;{{ fundInformationNav?.navDate }}
                        </span>
                      </span>
                    </div>
                    <div class="text-big">{{ navDroopdownValue ? navDroopdownValue : 'NA' }}</div>
                  </li>
                </ul>
                <div class="d-block d-lg-none">
                  <!--<button class="btn btn-light-blue"><span class="new-tag">New</span><i
                      class="bi bi-cart3"></i> Add to
                    cart
                  </button>-->
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-auto col-sm-auto" id="statick-graph" *ngIf="sinceInceptionReturn else showInvestBtn">
            <div class="returns-block">
              <!-- <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item" role="presentation">
                  <button class="nav-link active" id="monthly-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#monthly-tab-pane" type="button" role="tab"
                          aria-controls="monthly-tab-pane" aria-selected="true" (click)="loadSipData()">
                    {{ "products.fund-header-monthly-sip" | translate }}
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button class="nav-link" id="monthly-tab" data-bs-toggle="tab"
                          data-bs-target="#monthly-tab-pane" type="button" role="tab"
                          aria-controls="monthly-tab-pane" aria-selected="false" (click)="loadLumpsumData()">
                    {{ "products.fund-header-lumpsum" | translate }}
                  </button>
                </li>
              </ul> -->
              <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade show active" id="monthly-tab-pane" role="tabpanel"
                     aria-labelledby="monthly-tab" tabindex="0">
                  <div class="graph-box">
                    <!-- <div class="text-semi-big text-center">
                      <span class="text-gray annualised-return" style="cursor: pointer;"
                            (click)="moveToPerformance()">
                        {{ "products.fund-header-annualised-returns" | translate }}
                      </span>
                      <div class="dropdown small-dropdown">
                        <button class="btn btn-white dropdown-toggle" type="button"
                                id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                          {{ selectedPerfPeriodValue }}
                        </button>
                        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                          <li *ngFor="let menu of perfDropdownItems"
                              (click)="onPerfPeriodChange(menu)"><a
                              class="dropdown-item item-cursor">{{ menu.label }}</a></li>
                        </ul>
                      </div>
                    </div> -->
                    <!-- <div class="return-graph py-4" *ngIf="perfValue !=='-' else noReturns">
                      <ng-container *ngFor="let percent of options; let i= index;">
                        <div class="custom-wid" *ngIf="percent.value !== undefined && isBenchmarkGraph">
                          <div class="graph graph1" *ngIf="percent.value > 0; else percentNegativeValue">
                            <circle-progress
                                #circleProgress
                                [percent]="percent.value"
                                [backgroundGradient]="true"
                                [radius]="35"
                                [showZeroOuterStroke]="true"
                                [space]="-7"
                                [outerStrokeGradient]="true"
                                [outerStrokeWidth]="7"
                                [innerStrokeWidth]="5"
                                [outerStrokeColor]="'#583EE7'"
                                [animateTitle]="false"
                                [outerStrokeGradientStopColor]="'#00B6AE'"
                                [innerStrokeColor]="'#fff'"
                                [animationDuration]="300"
                                [animation]="false"
                                [showUnits]="showTitle(percent.value)"
                                [unitsColor]="'#00847D'"
                                [subtitleColor]="'#00847D'"
                                [unitsFontSize]="16"
                                [titleFontSize]="16"
                                [titleColor]="'#00847D'"
                                [showBackground]="false"
                                [clockwise]="true"
                                [startFromZero]="true"
                                [subtitleFontSize]="16"
                                [showSubtitle]="showSubtitle(percent.value)"
                                [subtitle]="getSubtitle(percent.value)"
                                [showTitle]="showTitle(percent.value)"
                                [lazy]="false"
                                [responsive]="true"
                                [renderOnClick]="true"
                                [toFixed]=2
                            >
                            </circle-progress>
                          </div>
                          <ng-template #percentNegativeValue>
                            <div class="bm--ve-val">{{ percent.value }}</div>
                          </ng-template>
                          <span *ngIf="percent.value !== undefined">{{ percent.bmName }}</span>
                        </div>
                      </ng-container>
                    </div> -->
                    <ng-template #noReturns>
                      <div class="customP extra-pad text-center">
                        {{ "products.fund-header-return-not-available" | translate }}
                      </div>
                    </ng-template>
                    <div class="block-btns text-center" style="display: block;"
                         [ngStyle]="{'cursor': !fundDocument.enableinvestnow ? 'not-allowed' : 'pointer'}">
                      <button (click)="onInvestNow()"
                              class="btn btn-primary fund-invest-btn"
                              [disabled]="!fundDocument.enableinvestnow">
                        {{ "products.fund-listing-button-invest-now" | translate }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ng-template #showInvestBtn>
            <div class="col-lg-auto col-sm-auto" id="static-graph" style="width: auto;">
              <div class="block-btns text-center">
                <div style="width: 315px;">
                  <div class="tab-content">
                    <div class="tab-pane fade show active">
                      <div class="graph-box"
                           [ngStyle]="{'cursor': !fundDocument.enableinvestnow ? 'not-allowed' : 'pointer'}">
                        <button (click)="onInvestNow()" class="btn btn-primary fund-invest-btn"
                                [disabled]="!fundDocument.enableinvestnow" style="width:100%">
                          {{ "products.fund-listing-button-invest-now" | translate }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
  <!-- save to watchlist alert -->
  <div class="save-alert" *ngIf="showSaveDialoge">
    <div class="content">
      <span class="close-btn" (click)="toggleShowSavDialoge()">
        <img alt='image' src="assets/images/general/close.webp">
      </span>
      <img alt='image' src="assets/images/general/check_circle.svg" class="checked-img">
      <span>{{ "products.funds-home-card-watchlist-success" | translate }}</span>
      <a (click)="routeModuleWatchList()"
         class="btn btn-primary">{{ "products.funds-home-card-go-watchlist-btn" | translate }}</a>
    </div>
  </div>
  <!-- Dialoge: Remove from watchlist alert -->
  <div class="save-alert" style="z-index:10000" *ngIf="showRemoveDialoge">
    <div class="content">
      <span class="close-btn" (click)="closeRemoveWatchListDialoge('close')">
        <img alt='image' src="assets/images/general/close.webp">
      </span>
      <img alt='image' src="assets/images/general/check_circle.svg" class="checked-img">
      <span>{{ "products.funds-home-card-watchlist-remove" | translate }}</span>
      <a class="btn btn-primary"
         (click)="routeModuleWatchList()">{{ "products.funds-home-card-go-watchlist-btn" | translate }}</a>
    </div>
  </div>
  <!--copy alert -->
  <div class="save-alert copy-alert" *ngIf="showCopyDialoge">
    <div class="content">
      <span class="close-btn" (click)="toggleShowCopyDialoge(false)">
        <img alt='image' src="assets/images/general/close.webp">
      </span>
      <img alt='image' src="assets/images/general/check_circle.svg" class="checked-img">
      <div class="mb-3">{{ "products.home-fund-card-link-copied-label" | translate }}</div>
      <div class="link-box">{{ linkToCopy }}</div>
    </div>
  </div>

  <div class="modal fade" id="callBack1" tabindex="-2" aria-labelledby="callBackLabel1" aria-hidden="true" style="
    position: fixed;
    top:  calc(43% - 75px);
    width: -webkit-fill-available;
    display: none;
    z-index:1201;
 ">
    <div class="modal-dialog modal-dialog-centered" style="padding:0;margin:0;">
      <div class="modal-content" style="border-top-right-radius:15%; border-top-left-radius: 15%;">
        <div class="line"></div>
        <div class="modal-header">
          <div class="modal-title" id="callBackLabel1" style="font-size:1.75rem;margin-left:auto">Share with
            others
          </div>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row text-center mb-4">
            <div class="col-3">
              <a (click)="shareOnApp('FACEBOOK')" class="share-btn">
                <img alt='image' src="assets/images/home/Framefacebook.png">
              </a>
            </div>
            <div class="col-3">
              <a (click)="shareOnApp('TWITTER')" class="share-btn">
                <img alt='image' src="assets/images/home/Frametwitter.png">
              </a>
            </div>
            <div class="col-3">
              <a (click)="shareOnApp('WHATAPP')" class="share-btn">
                <img alt='image' src="assets/images/home/Framewhatsapp.png">
              </a>
            </div>
            <div class="col-3">
              <a (click)="shareOnApp('LINKEDIN')" class="share-btn">
                <img alt='image' src="assets/images/home/Framelinkedin.png">
              </a>
            </div>
          </div>
          <div class="link-block d-flex justify-content-between">
            <div class="link" style="border: 1px solid #D2D8EA;padding: 12px;">
              {{ linkToCopy }}
            </div>
            <button class="btn btn-outline-primary" (click)="toggleShowCopyDialoge(true)">Copy Link</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="invest-now" class="d-none">
    <a class="btn btn-primary btn-sm"
       (click)="onInvestNow()">{{ "products.fund-listing-button-invest-now" | translate }}</a>
  </div>
</ng-container>

<ng-template #previewBlock>
  <h5 *ngIf="page && page.isPreview()">
    Fund Content Component - {{ brConfig.location }}
  </h5>
</ng-template>

<!-- Dialoge: save to Compared Card alert -->
<div class="save-alert" style="z-index:10000" *ngIf="showComparedDialoge">
  <div class="content">
    <span class="close-btn" (click)="closeAddCompareDialoge('close')">
      <img alt='image' src="assets/images/general/close.webp">
    </span>
    <img alt='image' src="assets/images/general/check_circle.svg" class="checked-img">
    <span> {{ "products.funds-home-card-compare-success" | translate }}</span>
    <a class="btn btn-primary"
       (click)="routeModuleCompareFund()">{{ "products.funds-home-card-goto-compare" | translate }}
    </a>
  </div>
</div>

<!-- Dialoge: Remove from Compared Card alert -->
<div class="save-alert" style="z-index:10000" *ngIf="removeCompareDialoge">
  <div class="content">
    <span class="close-btn" (click)="closeRemoveCompareDialoge('close')">
      <img alt='image' src="assets/images/general/close.webp">
    </span>
    <img alt='image' src="assets/images/general/check_circle.svg" class="checked-img">
    <span>{{ "products.funds-home-card-compare-remove" | translate }}</span>
    <a class="btn btn-primary"
       (click)="routeModuleCompareFund()">{{ "products.funds-home-card-goto-compare" | translate }}</a>
  </div>
</div>

<!-- Dialoge: Compare Error Card alert -->
<div class="save-alert" style="z-index:10000" *ngIf="showCompareErrorDialoge">
  <div class="content">
    <span class="close-btn" (click)="closeCompareErrorDialoge('close')">
      <img alt='image' src="assets/images/general/close.webp">
    </span>
    <img alt='image' src="assets/images/general/check_circle.svg" class="checked-img">
    <span>{{ "products.funds-home-card-compare-error" | translate }}</span>
    <a class="btn btn-primary"
       (click)="routeModuleCompareFund()">{{ "products.funds-home-card-goto-compare" | translate }}</a>
  </div>
</div>

<!-- Dialoge: Max allowed alert -->
<div class="save-alert" style="z-index:10000" *ngIf="compareFull || watchListFull">
  <div class="content">
    <ng-container *ngIf="compareFull">
      <span class="close-btn" (click)="closeCompareOrWatchlistFull('compare')">
        <img alt='image' src="assets/images/general/close.webp">
      </span>
      <span style="font-size: 1.063rem;">{{ "products.funds-home-card-compare-error" | translate }}</span>
      <a class="btn btn-primary"
         (click)="routeModuleCompareFund()">{{ "products.funds-home-card-goto-compare" | translate }}</a>
    </ng-container>
    <ng-container *ngIf="watchListFull">
      <span class="close-btn" (click)="closeCompareOrWatchlistFull('watchlist')">
        <img alt='image' src="assets/images/general/close.webp">
      </span>
      <span> {{ "products.add-fund-watch-list-max-limit-message" | translate }} </span>
      <a class="btn btn-primary"
         (click)="routeModuleWatchList()">{{ "products.funds-home-card-go-watchlist-btn" | translate }}
      </a>
    </ng-container>
  </div>
</div>
